import React, { useState } from 'react';

interface PasswordResetModalProps {
  onSubmit: (email: string) => void;
  onClose: () => void;
}

const PasswordResetModal: React.FC<PasswordResetModalProps> = ({ onSubmit, onClose }) => {
  const [resetEmail, setResetEmail] = useState('');

  return (
    <div
      style={{
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
          width: '400px',
        }}
      >
        <h2>비밀번호 재설정</h2>
        <p style={{ fontSize: '14px', color: '#555', textAlign: 'left' }}>
          비밀번호를 재설정 하기 위해 사용자 이메일을 입력해주세요. <br />
        </p>

        <input
          type="email"
          placeholder="Email"
          value={resetEmail}
          onChange={e => setResetEmail(e.target.value)}
          style={{
            width: '90%',
            padding: '10px',
            marginBottom: '15px',
            border: '1px solid #ccc',
            borderRadius: '4px',
          }}
        />

        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <button
            style={{
              padding: '10px 15px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: '#28a745',
              color: '#fff',
              cursor: 'pointer',
            }}
            onClick={() => onSubmit(resetEmail)}
          >
            Submit
          </button>
          <button
            style={{
              padding: '10px 15px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: '#dc3545',
              color: '#fff',
              cursor: 'pointer',
            }}
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetModal;
